export default __webpack_public_path__ + "static/media/walletconnect_icon.4f717b04.png";